import React, { useState, useEffect, useRef } from "react";
import { useMutation, useManualQuery } from "graphql-hooks";
import { useNavigate } from "react-router-dom";
import {
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import Box from "@mui/material/Box";

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { project_url } from "../../constants/Data";

import { GET_APPLICANT_DATA_BY_TERM_APPLICANT_ID_QUERY, EDIT_TERM_APPLICANT_OPT_IN_OUT_MUTATE } from "../../graphQL/term_applicant_qry";

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },

  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginLeft: 5,
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
  textFieldInput: {
    resize: "Vertical",
    height: "150px",
    maxHeight: "150px",
    width: "500px",
    maxWidth: "550px",
  },
}));

export default function EditTermApplicantNoteDialog({
  termApplicantId,  
  closeDialog,
  handleDone,
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [termApplicant, setTermApplicant] = useState([]);  
  const [notes, setNotes] = useState("");  
  const [optInOutDecision, setOptInOutDecision] = useState(true);  
  const [applicantName, setApplicantName] = useState("");
  const [lastUpdate, setLastUpdate] = useState("");  
  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat = format!== null 
                      ? 
                        formatter1.formatToParts(dayDate)
                      :
                        formatter2.formatToParts(dayDate)
                      ;    
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "day").value +
        " " +
        dayFormat.find((a) => a.type == "month").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "YYYYmonthDD"){
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value +
        ", " +
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        "/" +
        dayFormat.find((a) => a.type == "day").value +
        "/" +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    }
  };
  
  const [getTermApplicantQuery] = useManualQuery(GET_APPLICANT_DATA_BY_TERM_APPLICANT_ID_QUERY);

  const getTermApplicantData = async () => {
    
    const { loading, error, data } = await getTermApplicantQuery({
      variables: {
        termApplicantId: parseInt(termApplicantId),
      },
    });    
    if (!loading && data && data.getApplicantDataByTermApplicantId) {
            
      setTermApplicant(data.getApplicantDataByTermApplicantId);
      setApplicantName(data.getApplicantDataByTermApplicantId.applicantId.userId.firstName + " " + data.getApplicantDataByTermApplicantId.applicantId.userId.lastName)
      setNotes(data.getApplicantDataByTermApplicantId.note);
      setOptInOutDecision(data.getApplicantDataByTermApplicantId.optInOutDecision);
      
      setLastUpdate(dayFormat(data.getApplicantDataByTermApplicantId.updateDate, "monthDDYYYY") + " - " + data.getApplicantDataByTermApplicantId.updateBy.split(":")[1]);
    }
    if (error) {
      navigate(`${project_url}/signin`);
    }
  };

  useEffect(() => {
    (() => getTermApplicantData())();
  }, []);

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleChange = event => {    
    setNotes(event.target.value);
  };

  const handleRadioChange = event => {
    
    setOptInOutDecision(event.target.value);
  };

  const [editTermApplicantOptInOut] = useMutation(EDIT_TERM_APPLICANT_OPT_IN_OUT_MUTATE);
  
  const handleSave = async () => {
    
    let opt = JSON.parse(optInOutDecision)
    
    const { loading, data, error } = await editTermApplicantOptInOut({
      variables: {
        termApplicantId: parseInt(termApplicantId),
        optInOutDecision: opt,
        note: notes,
      },
    });
    if (error) {
      alert("Unfortunately an error occurred.");
    } else if (data && data.editTermApplicantOptInOut) {
      handleClose();
    }
    else
      handleClose();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              height: "100%",
              maxWidth: "600px",
              maxHeight: "500px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 15,
          }}
        >
          <Box mt={1} ml={1}>
            {applicantName}
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box style={{ width: "fit-content" }}>
              <Typography
                variant="h3"
                style={{
                  fontSize: 15,
                  
                  marginBottom: "1rem",
                  color: "#000",
                }}
              >
                Last Updated: {lastUpdate}
              </Typography> 
              <Typography variant="h3"  style={{fontSize: 18,marginBottom: "1rem",color: "#000",}}>
                  Opt In/Out:&nbsp;&nbsp;

                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={optInOutDecision}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel value="true" control={<Radio />} label="In" />
                    <FormControlLabel value="false" control={<Radio />} label="Out" />
                    
                  </RadioGroup>

              </Typography>
              

              <TextField
                id="notes"
                variant="outlined"
                multiline
                fullWidth
                autoFocus                
                label="Notes"
                margin="normal"
                name="notes"
                rows={4}
                className={classes.textFieldStyle}
                defaultValue={notes}
                InputProps={{
                  classes: {
                    input: classes.textFieldInput,
                  },
                }}
                onChange={handleChange}
              />
            </Box>
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ justifyContent: "center", marginTop: 15 }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
